import React from "react";
import { Route, Routes } from "react-router-dom";
import Social from "../Pages/Social/Social";
import SocialDashboard from "../Pages/Social/Dashboard/SocialDashboard";
import Diversity from "../Pages/Social/FormData/Diversity";
import LabourPractices from "../Pages/Social/FormData/LabourPractices";
import CustomerSatisfaction from "../Pages/Social/FormData/CustomerSatisfaction";
import WellBeing from "../Pages/Social/FormData/WellBeing";
import HealthAndSafety from "../Pages/Social/FormData/HealthAndSafety";
import HumanRights from "../Pages/Social/FormData/HumanRights";
import TrainingAndDevelopment from "../Pages/Social/FormData/TrainingAndDevelopment";
import EmployeeBenifit from "../Pages/Social/FormData/EmployeeBenifit";
import CommunityEngagement from "../Pages/Social/FormData/CommunityEngagement";
import SocialData from "../Pages/Social/Data/Data";
import SocialList from "../Pages/Social/List";

export const SocialRoutes = [
  { path: "/social/dashboard", element: <SocialDashboard /> },
  { path: "/social/list", element: <SocialList /> },
  { path: "/social/data", element: <SocialData /> },
  {
    path: "/social/data/diversity-and-inclusion/:id",
    element: <Diversity />,
  },
  {
    path: "/social/data/labour-practices/:id",
    element: <LabourPractices />,
  },
  {
    path: "/social/data/customer-satisfaction/:id",
    element: <CustomerSatisfaction />,
  },
  {
    path: "/social/data/employee-wellbeing/:id",
    element: <WellBeing />,
  },
  {
    path: "/social/data/health-safety/:id",
    element: <HealthAndSafety />,
  },
  { path: "/social/data/human-rights/:id", element: <HumanRights /> },
  {
    path: "/social/data/training-development/:id",
    element: <TrainingAndDevelopment />,
  },
  {
    path: "/social/data/employee-benefit/:id",
    element: <EmployeeBenifit />,
  },
  {
    path: "/social/data/community-engagement/:id",
    element: <CommunityEngagement />,
  },
];
